"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHelmet = require("react-helmet");

var _PageLoadingSpinner = _interopRequireDefault(require("@jobmatchme/ui/es/components/PageLoadingSpinner"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ExportAppContainer = /*#__PURE__*/(0, _react.lazy)(function () {
  return import(
  /* webpackChunkName: 'faq' */
  './');
});

var _default = function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("title", null, "FAQ: Fragen rund um TruckJobs by JOBMATCH.ME"), /*#__PURE__*/_react.default.createElement("meta", {
    name: "description",
    content: "H\xE4ufig gestellte Fragen rund um TruckJobs. Wie funktioniert und f\xFCr wen ist Truckjobs gedacht? Hier bekommen Sie Ihre Antwort!"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "keywords",
    content: "LKW Fahrer Job, LKW Fahrer gesucht, Kraftfahrer Job, LKW Fahrer Stellenangebote, Kraftfahrer Stellenangebote, Kraftfahrer gesucht"
  })), /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_PageLoadingSpinner.default, {
      fullHeight: true
    })
  }, /*#__PURE__*/_react.default.createElement(ExportAppContainer, props)));
};

exports.default = _default;